<app-generic-editor [autoFlow]="true" [autoFlowWidthThreshold]="99999">
  <div small style="height: 100%">
    <app-field-wrapper labelsWidth="103px">
      <w-boolean-field *ngIf="!existing" label="NEW?" [(value)]="newLead.value"
                       (valueChange)="onNewLead($event)"></w-boolean-field>
      <!--  Lead Name Or Customer Id-->
      <w-text-field *ngIf="newLead.value && !existing" label="Company:" [(value)]="lead.companyName"></w-text-field>
      <w-text-field *ngIf="newLead.value && !existing" label="Contact:" [(value)]="lead.name"></w-text-field>
      <w-customer-field *ngIf="!newLead.value && !existing" label="Client:" [customer]="communicationCustomer"
                        (valueChange)="customerChangeHandler($event)" placeholder="Search contact"></w-customer-field>

      <!--  Type and Direction-->
      <w-multi-column-field [widthSplits]="['73%', '2%', '25%']" [isLabel]="[false, false, false]">
        <w-single-select c0 label="Type:" [options]="commTypeOptions" [(value)]="communicationType"
                         (valueChange)="commTypeChangeHandler($event)"></w-single-select>
        <w-multi-column-separator c1></w-multi-column-separator>
        <w-single-select c2 [hideLabel]="true" [options]="commDirectionOptions" [(value)]="communicationDirection"
                         (valueChange)="commDirectionChangeHandler($event)"></w-single-select>
      </w-multi-column-field>
      <w-multi-column-field [widthSplits]="['50%', '50%']" [isLabel]="[false, false]">
        <w-date-field c0 label="Date:" [(value)]="comm.communication.eventDate"></w-date-field>
        <w-time-field c1 label="Time:" [(value)]="comm.communication.eventDate"></w-time-field>
      </w-multi-column-field>

      <!--  Contact Name if it's already a customer-->
      <div class="name-text-field">
        <w-text-field *ngIf="!newLead.value" label="Name:" [(value)]="comm.communication.personName"
                      placeholder="eg. Maria"></w-text-field>
      </div>
      <!--  Extra information about the lead-->
      <w-text-field *ngIf="newLead.value && !existing" label="Email:" [(value)]="lead.email"></w-text-field>
      <w-text-field *ngIf="newLead.value && !existing" label="Phone:" [(value)]="lead.phoneNumber"></w-text-field>

      <!--  Mail Only Extras-->
      <div *ngIf="comm.communication.type === CommunicationType.Mail">
        <w-text-field label="Tracking:" [(value)]="comm.mail.trackingNumber"></w-text-field>
        <w-carrier-single-select label="Carrier:" [(value)]="comm.mail.carrier"></w-carrier-single-select>
        <w-multi-column-field [widthSplits]="['50%', '50%']" [isLabel]="[false, false]">
          <w-boolean-field c0 label="Scanned?" [(value)]="comm.mail.hasDateScanned"></w-boolean-field>
          <w-date-field c1 *ngIf="comm.mail.hasDateScanned" label="Scan Date:"
                        [(value)]="comm.mail.dateScanned"></w-date-field>
        </w-multi-column-field>
      </div>

      <!--  Flag for existing entries-->
      <w-flag-single-select c0 label="Flag:" [value]="comm.communication.flagged ? comm.communication.flagColor : -1"
                            (valueChange)="handleFlagColorChange($event)"></w-flag-single-select>


      <!--  Lead Notes or Communication Details-->
      <app-html-document-editor [(html)]="comm.communication.description" [customerId]="comm.communication.customerId"
                                class="comm-ck" [class.extended]="existing"></app-html-document-editor>
    </app-field-wrapper>
  </div>
</app-generic-editor>
